import { z } from 'zod';
import { AllowedOpenAiModels } from 'libs/end-to-end/src/types/databases/data-sets/data-set-resume-rubric';
import { SelectiveFilterStringBasedOption } from 'libs/end-to-end/src/selective-filtering/selective-filter-matching-option';

export const SupplementalDataSetResumeGradingRubricV2 = z.object({
  filter: SelectiveFilterStringBasedOption,
  rubricConstructId: z.string(),
});

export type SupplementalDataSetResumeGradingRubricV2 = z.infer<
  typeof SupplementalDataSetResumeGradingRubricV2
>;

export const SupplementalResumesDataSetConfig = z.object({
  dataSetType: z.literal('Supplemental'),
  supplementalDataSetType: z.literal('resumes'),
  rubricsByJobTitle: z
    .array(SupplementalDataSetResumeGradingRubricV2)
    .nullable()
    .optional(),
  openAiModel: AllowedOpenAiModels.default('gpt-4o-mini'),
  enableCompositeResumeScoring: z.boolean().default(false),
  useV2Grading: z.boolean().default(false),
});

export type SupplementalResumesDataSetConfig = z.infer<
  typeof SupplementalResumesDataSetConfig
>;

const SupplementalPayBenchmarkingDataSetConfig = z.object({
  dataSetType: z.literal('Supplemental'),
  supplementalDataSetType: z.union([
    z.literal('external_pay_benchmarking'),
    z.literal('internal_pay_benchmarking'),
  ]),
});

export const SupplementalDataSetConfig = z.union([
  SupplementalResumesDataSetConfig,
  SupplementalPayBenchmarkingDataSetConfig,
]);

export type SupplementalDataSetConfig = z.infer<
  typeof SupplementalDataSetConfig
>;
